import { SearchInput } from '../shared';
import { SortOrder, ProjectChecklistSortType } from '../enums';

export class GetProjectChecklistsInput extends SearchInput<ProjectChecklistSortType> {
    public projectId = 0;

    constructor() {
        super(ProjectChecklistSortType.Order);
        this.sortOrder = SortOrder.Ascending;
    }
}
